let _ = require('lodash');
let moment = require('moment');



export let colAcFinancialComp = {   colId: 'acuteCareComp',
                                    headerName: 'Comp Max/Fixed',
                                    field: 'acuteCareComp',
                                    width: 100,
                                    sortable: true};

export let colAcFinancialBonus = {  colId: 'acuteCareBonus',
                                    headerName: 'Bonus Information',
                                    field: 'acuteCareBonus',
                                    width: 100,
                                    sortable: true};

export let colAcFinancialCritical = {   colId: 'acuteCareCritical',
                                        headerName: 'DNV Critical or Non-Critical',
                                        field: 'acuteCareCritical',
                                        width: 100,
                                        sortable: true};

export let colAcFinancialHourlyRate = { colId: 'acuteCareHourlyRate',
                                        headerName: 'Hourly Rate',
                                        field: 'acuteCareHourlyRate',
                                        width: 100,
                                        sortable: true};

export let colAcFinancialMeanFMV = {colId: 'acuteCareMeanFMV',
                                    headerName: 'Mean FMV',
                                    field: 'acuteCareMeanFMV',
                                    width: 100,
                                    sortable: true};

export let colAcFinancialRangeFMV = {   colId: 'acuteCareRangeFMV',
                                        headerName: 'Range of FMV',
                                        field: 'acuteCareRangeFMV',
                                        width: 100,
                                        sortable: true};

export let colAcFinancialSpecialty = {  colId: 'acuteCareSpecialty',
                                        headerName: 'Specialty',
                                        field: 'acuteCareSpecialty',
                                        width: 100,
                                        sortable: true};

// export let colAcKeyTerms = {  colId: 'acuteCareKeyTerms',
//                                         headerName: 'Key Terms',
//                                         field: 'acuteCareKeyTerms',
//                                         width: 100,
//                                         sortable: true};

export let colAcSquareFootage = {  colId: 'acuteCareSquareFootage',
                                        headerName: 'Square Footage',
                                        field: 'acuteCareSquareFootage',
                                        width: 100,
                                        sortable: true};

export let allColumns = [
    colAcFinancialComp,
    colAcFinancialBonus,
    colAcFinancialCritical,
    colAcFinancialHourlyRate,
    colAcFinancialMeanFMV,
    colAcFinancialRangeFMV,
    colAcFinancialSpecialty,
    // colAcKeyTerms,
    colAcSquareFootage
];



export let columnSelectList = [
    {
        value: colAcFinancialComp,
        viewValue: colAcFinancialComp.headerName
    },
    {
        value: colAcFinancialBonus,
        viewValue: colAcFinancialBonus.headerName
    },
    {
        value: colAcFinancialCritical,
        viewValue: colAcFinancialCritical.headerName
    },
    {
        value: colAcFinancialHourlyRate,
        viewValue: colAcFinancialHourlyRate.headerName
    },
    {
        value: colAcFinancialMeanFMV,
        viewValue: colAcFinancialMeanFMV.headerName
    },
    {
        value: colAcFinancialRangeFMV,
        viewValue: colAcFinancialRangeFMV.headerName
    },
    {
        value: colAcFinancialSpecialty,
        viewValue: colAcFinancialSpecialty.headerName
    },
    // {
    //     value: colAcKeyTerms,
    //     viewValue: colAcKeyTerms.headerName
    // },
    {
        value: colAcSquareFootage,
        viewValue: colAcSquareFootage.headerName
    }
];




function  dateFormatter(params) {

    if (params.value == undefined) {
        return 'none';
    } else {
        let dateObject = moment(params.value);
        let friendlyDate = dateObject.format('ll');

        if (friendlyDate == 'Invalid date') {
            // console.log('invalid date: ', params.value);
            return params.value;
        } else {
            // console.log('valid date: ', friendlyDate);
            return friendlyDate;
        }
    }
}

function dateExpired(param) {

    if (param.value != undefined) {
        let dateToEvaluate = moment(param.value);

        let daysPast = moment().diff(dateToEvaluate, 'days');
        // console.log('days past: ', daysPast);

        if (daysPast >= 0) {
        return {color: 'black', backgroundColor: 'red'};
        } else if (daysPast >= 180) {
        return {color: 'black', backgroundColor: 'yellow'};
        }
    }

}




function currencyFormatter(params) {

    let usdFormate = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });

    if (usdFormate.format(params.value) == '$0' ||
        (usdFormate.format(params.value) == '$NaN')) {
      return '$0.00';
    } else {
      return usdFormate.format(params.value);
    }

  }


function riskFormatter(param) {

    console.log('riskFormatter: ', param.data.riskScore);

    let scoreAsNumber = Number(param.data.riskScore);
    let scoreAsFloat = scoreAsNumber.toFixed(1);

    console.log('scoreAsFloat: ', scoreAsFloat);

    if ((scoreAsFloat != undefined) &&
        (scoreAsFloat != 'NaN')) {
      return scoreAsFloat;
    } else {
      return '';
    }
  }


